import { render, staticRenderFns } from "./SettlementStatusBadge.vue?vue&type=template&id=639b3721&scoped=true&"
import script from "./SettlementStatusBadge.vue?vue&type=script&lang=js&"
export * from "./SettlementStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./SettlementStatusBadge.vue?vue&type=style&index=0&id=639b3721&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b3721",
  null
  
)

export default component.exports